/**
 * Created by Miguel on 23/05/2017
 */
import { Component, OnInit,ChangeDetectionStrategy, ViewEncapsulation,OnDestroy  } from '@angular/core';
import { ActivatedRoute,RouterLink} from '@angular/router';
import { CompanyService }  from '../../../../services/company.service';
import { AppDataService }  from '../../../../services/app-data.service';
import {TranslationService} from '../../../../services/translation.service';
import { Alert } from 'selenium-webdriver';
import {UserService} from "../../../../services/user.service";

declare var $ : any;
declare var Recorder: any;

@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.Emulated,
    selector : 'chat-screen',
    templateUrl:'chat.component.html',
    providers  : []
})
export class ChatScreenComponent implements OnInit , OnDestroy{

  public talkhere=""


  public notifications=[];
  public messages=[];
  public chatReference;
  public recording;
  public user;
  public rec;
  public gumStream;
  constructor(private _companyService : CompanyService, private _userService:UserService, public _appData : AppDataService, public translate: TranslationService) {
    }

    public ngOnDestroy() : any {
      this.chatReference.off();
    }
  
    public reload(): void{
      this._initializeAppData();
      this._appData.tiping=true;
      $(window).scrollTop(0);
    }
    private _initializeAppData() : void {
      //this can come either from an event or from a user.
      this.talkhere=this.translate.instant('TALKHERE')
      this.user=this._appData.instagramUser;
      let uid=this._appData.instagramUser.uid;
      let talkTo=this._appData.talkTo.uid;
      var n = uid.localeCompare(talkTo);
      let link='';
      if (n>0){
          link=uid+"_"+talkTo;
      }else{
        link=talkTo+"_"+uid;
      }

      this.chatReference=this._companyService.getUserMessages(link).on("child_added", (snapshot, prevChildKey) =>{     
        let date=new Date();
        let mymessages=this.messages;
        if (!mymessages) mymessages=[];
        let _messages=snapshot.val();
        let milis=_messages.createdAt;//last 10 minutes
        //normal messages
        let dt=this.longToDate(milis)
        _messages.date=dt;

        if (_messages.text.indexOf('.jpeg')>0 ){
          _messages.type='img'
        }
        else if (_messages.text.indexOf('.png')>0 ){
          _messages.type='img'
        }
        else if (_messages.type=='file') {
          if (!_messages.name){
            _messages.name='download'
          }
        }


        this.messages.push(_messages)
        setTimeout(()=>{
          var objDiv = document.getElementById("mobileMessages");
          objDiv.scrollTop = objDiv.scrollHeight; 
        },500)


                
      });
    }
    public isUrl(str) {
      var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
        '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
      return !!pattern.test(str);
    }
    
    public recordAudio(){
      let date=new Date();
      this.recording=date.getTime();
      var constraints = {
        audio: true,
        video: false
    } 

    var AudioContext = window.AudioContext || window['webkitAudioContext'];
    var audioContext = new AudioContext;
    //Recorder.js object 
    var input;
      navigator.mediaDevices.getUserMedia(constraints).then((stream) =>{
        console.log("getUserMedia() success, stream created, initializing Recorder.js ..."); 
        /* assign to gumStream for later use */
        this.gumStream = stream;
        /* use the stream */
        input = audioContext.createMediaStreamSource(stream);
        /* Create the Recorder object and configure to record mono sound (1 channel) Recording 2 channels will double the file size */
        this.rec = new Recorder(input, {
            numChannels: 1
        }) 
        //start the recording process 
        this.rec.record()
        console.log("Recording started");
    }).catch(function(err) {
        //enable the record button if getUserMedia() fails 
/*        recordButton.disabled = false;
        stopButton.disabled = true;
        pauseButton.disabled = true*/
    });

    }
    public stopRecordAudio(){
      let date=new Date();
      let time=date.getTime();
      this.rec.stop();
      this.gumStream.getAudioTracks()[0].stop();
      if ((time-this.recording)>2000){
        this.rec.exportWAV((blob)=>{this.createDownloadLink(blob)});
      }


    }
    public uploadImage() {
      $('#cellChatImageUpdate').click();
    }
  
  
    public fileEvent(fileInput: any){
      var file = fileInput.target.files[0];
      let filename: string = file.name;
      let newfile = filename;//.substr(idx,4);
      this._userService.uploadToFirebase(file, newfile, 'userprofile/'+this._appData.instagramUser.uid+'/chatFiles').subscribe(snapshot =>{
        snapshot.ref.getDownloadURL().then(url => {
          let finalURL = url;
          let id=new Date();
          let msgObj={
            _id: id.getTime(),
            createdAt: id.getTime(),
            text:url,
            name:filename,
            type:'file',
            user:{
              _id: this._appData.instagramUser.uid,
              avatar: this._appData.instagramUser.profile_picture,
              name: this._appData.instagramUser.full_name
            }
          }
          var talkTo=this._appData.talkTo.uid;
          let source="userChat"
          var link=url;
          //user on a talkTo.
          let uid=this._appData.instagramUser.uid;
          var n = uid.localeCompare(talkTo);
          if (n>0){
              link=uid+"_"+talkTo;
          }else{
            link=talkTo+"_"+uid;
          }
          this._companyService.addUserMessage(source,link,
            msgObj).then((data)=>{
              setTimeout(()=>{
                var objDiv = document.getElementById("mobileMessages");
                objDiv.scrollTop = objDiv.scrollHeight; 
              },2000)
              //success callback
              //If the event message was sent i may have to warn the user about it....
              //if i am sending a message to someone else
              this._companyService.sendNotificationToSomeoneElse(null,this._appData.instagramUser,this._appData.talkTo,"Você recebeu uma mensagem",url,"newCellMessage",this._appData.instagramUser.profile_picture,true)
           
            }).catch((error)=>{
              //error callback
              console.log('error')       
              console.log(error)
        
            })       
        })
  
      });
    }
    public createDownloadLink(blob){
      let date=new Date();
      let milis=date.getTime()
      var file = new File([blob], milis.toString()+'.wav',{type:"audio/wav"});
      this._userService.uploadToFirebase(file,milis.toString()+'.wav', 'userprofile/'+this._appData.instagramUser.uid+'/waves').subscribe(snapshot =>{
        snapshot.ref.getDownloadURL().then(url => {
          let id=new Date();
          let msgObj={
            _id: id.getTime(),
            createdAt: id.getTime(),
            text:url,
            type:'wav',
            user:{
              _id: this._appData.instagramUser.uid,
              avatar: this._appData.instagramUser.profile_picture,
              name: this._appData.instagramUser.full_name
            }
          }
          var talkTo=this._appData.talkTo.uid;
          let source="userChat"
          var link=url;
          //user on a talkTo.
          let uid=this._appData.instagramUser.uid;
          var n = uid.localeCompare(talkTo);
          if (n>0){
              link=uid+"_"+talkTo;
          }else{
            link=talkTo+"_"+uid;
          }
          this._companyService.addUserMessage(source,link,
            msgObj).then((data)=>{
              setTimeout(()=>{
                var objDiv = document.getElementById("mobileMessages");
                objDiv.scrollTop = objDiv.scrollHeight; 
              },2000)
              //success callback
              //If the event message was sent i may have to warn the user about it....
              //if i am sending a message to someone else
              this._companyService.sendNotificationToSomeoneElse(null,this._appData.instagramUser,this._appData.talkTo,"Você recebeu uma mensagem",url,"newCellMessage",this._appData.instagramUser.profile_picture,true)
           
            }).catch((error)=>{
              //error callback
              console.log('error')
        
              console.log(error)
        
            })       
        })
      });
    }
    public ngOnInit() : any {
 
    }
    public ngAfterContentInit(){
      var objDiv = document.getElementById("mobileMessages");
      objDiv.scrollTop = objDiv.scrollHeight;
    }
    public longToDate(number){
      let date=new Date(number)
      let day=date.getDate();
      let month=date.getMonth()+1;
      let monthStr=month.toString();
      if (monthStr.length==1) monthStr='0'+monthStr;
      let year=date.getFullYear();
      let hour=date.getHours();
      let hourStr=hour.toString();
      if (hourStr.length==1) hourStr='0'+hourStr;
      let minute=date.getMinutes()
      let minuteStr=minute.toString();
      if (minuteStr.length==1) minuteStr='0'+minuteStr;
  
      return day+'/'+monthStr+'/'+year+' '+hourStr+':'+minuteStr
  } 
    public newMessage() {
          let message = $("#mobileChatMessage").val();
          if($.trim(message) == '') {
            return false;
          }
          $("#mobileChatMessage").val('')
          let id=new Date();
          let islink=this.isUrl(message);
          let msgObj={
            _id: id.getTime(),
            createdAt: id.getTime(),
            text:message,
            link:islink,
            user:{
              _id: this._appData.instagramUser.uid,
              avatar: this._appData.instagramUser.profile_picture,
              name: this._appData.instagramUser.full_name
            }
          }

          var talkTo=this._appData.talkTo.uid;
          let source="userChat"
          var link=null;
          //user on a talkTo.
          let uid=this._appData.instagramUser.uid;
          var n = uid.localeCompare(talkTo);
          if (n>0){
              link=uid+"_"+talkTo;
          }else{
            link=talkTo+"_"+uid;
          }
          this._companyService.addUserMessage(source,link,
            msgObj).then((data)=>{
              setTimeout(()=>{
                var objDiv = document.getElementById("mobileMessages");
                objDiv.scrollTop = objDiv.scrollHeight; 
              },2000)
              //success callback
              //If the event message was sent i may have to warn the user about it....
              //if i am sending a message to someone else
              this._companyService.sendNotificationToSomeoneElse(null,this._appData.instagramUser,this._appData.talkTo,"Você recebeu uma mensagem",message,"newCellMessage",this._appData.instagramUser.profile_picture,true)
           
            }).catch((error)=>{
              //error callback
              console.log('error')
        
              console.log(error)
        
            })       
  }


    
}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/cellphone-modal/chat-screen/chat.component.ts